import { render, staticRenderFns } from "./detailDrPuttabanner.vue?vue&type=template&id=5580bed5&scoped=true"
import script from "./detailDrPuttabanner.vue?vue&type=script&lang=js"
export * from "./detailDrPuttabanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5580bed5",
  null
  
)

export default component.exports